import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { axiosBaseQuery } from './baseQuery';

export const editorConfigApi = createApi({
  reducerPath: 'editorConfig.api',
  baseQuery: axiosBaseQuery,
  // https://stackoverflow.com/questions/72687628/cannot-read-properties-of-undefined-reading-api-reducerpath-at-object-extrac
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['editorConfig', 'baseTemplateScene', 'baseTemplateConfig'],
  endpoints: (builder) => ({
    getEditorConfigs: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        productName = '',
        category = -1,
        subCategory = -1,
        language = 'KO',
        sort = 'CREATED_DATE_DESC',
      }) => ({
        url:
          `/api/editor-config?pageNo=${pageNo}&pageSize=${pageSize}&productName=${productName}` +
          (category === -1 ? '' : `&category=${category}`) +
          (subCategory === -1 ? '' : `&subCategory=${subCategory}`) +
          `&language=${language}` +
          `&sort=${sort}`,
      }),
      transformResponse: (response, meta: any) => {
        // console.log(response, meta);
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['editorConfig'],
    }),
    getEditorConfigById: builder.query({
      query: (id) => ({ url: `/api/editor-config/${id}` }),
      providesTags: ['editorConfig'],
    }),
    updateEditorConfig: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/api/editor-config/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['editorConfig'],
    }),
    addEditorConfig: builder.mutation({
      query: (body) => ({
        url: '/api/editor-config',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['editorConfig'],
    }),
    // base tempalte scene
    getBaseTemplateSceneById: builder.query({
      query: (id) => ({ url: `/api/editor-config/${id}/base-template-scene` }),
      providesTags: ['baseTemplateScene'],
    }),
    updateBaseTemplateScene: builder.mutation({
      query: ({ ecId, body }) => ({
        url: `/api/editor-config/${ecId}/base-template-scene`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['baseTemplateScene', 'baseTemplateConfig'],
    }),
    addBaseTemplateScene: builder.mutation({
      query: ({ ecId, body }) => ({
        url: `/api/editor-config/${ecId}/base-template-scene`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['baseTemplateScene'],
    }),
    deleteBaseTemplateScene: builder.mutation({
      query: ({ ecId, sceneId }) => ({
        url: `/api/editor-config/${ecId}/base-template-scene/${sceneId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['baseTemplateScene', 'baseTemplateConfig'],
    }),
    //base template config
    getBaseTemplateConfigById: builder.query({
      query: (id) => ({ url: `/api/editor-config/${id}/base-template-config` }),
      providesTags: ['baseTemplateConfig'],
    }),
    updateBaseTemplateConfig: builder.mutation({
      query: (body) => ({
        url: `/api/editor-config/${body.editorConfigId}/base-template-config`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['baseTemplateConfig'],
    }),
    addBaseTemplateConfig: builder.mutation({
      query: (body) => ({
        url: `/api/editor-config/${body.editorConfigId}/base-template-config`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['baseTemplateConfig'],
    }),
  }),
});

export const {
  useGetEditorConfigsQuery,
  useAddEditorConfigMutation,
  useGetEditorConfigByIdQuery,
  useUpdateEditorConfigMutation,

  useAddBaseTemplateSceneMutation,
  useGetBaseTemplateSceneByIdQuery,
  useUpdateBaseTemplateSceneMutation,
  useDeleteBaseTemplateSceneMutation,

  useGetBaseTemplateConfigByIdQuery,
  useAddBaseTemplateConfigMutation,
  useUpdateBaseTemplateConfigMutation,
} = editorConfigApi;
